<template>
  <div class="shop-edit-modal">
    <el-form
      class="detail-form"
      label-position="top"
      :model="formData"
      :rules="rules"
      ref="formRef"
    >
      <el-form-item label="门店名称：" prop="storeName">
        <el-input v-model="formData.storeName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="contact">
        <el-input
          maxlength="11"
          minlength="11"
          v-model="formData.contact"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="门店类型：" prop="storeType">
        <el-select
          v-model="formData.storeType"
          placeholder="请选择"
          class="w-p-100"
        >
          <el-option
            v-for="item in shopTypeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店地址：" prop="address">
        <AreaCascader v-model="fullArea" :end-level="2" :clearable="false" />
        <div class="detail-address">
          <el-input
            placeholder="请输入详细地址"
            v-model="formData.address"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="xpoint_ypoint" label="门店位置：">
        <el-row class="w-p-100 align-r">
          <el-col :span="21">
            <el-input
              class="m-r-10"
              :value="formData.xpoint + ',' + formData.ypoint"
              readonly
              placeholder="请选择"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="locationMapDialog = true"
              >选取</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <div style="color: green; font-size: 18px;">入离时间设置：</div>
      <el-form-item prop="bookStartTime" label="默认入住时间：">
        <el-time-picker v-model="formData.bookStartTime"
              format="HH:mm"
              value-format="HH:mm" placeholder="请输入" />
      </el-form-item>
      <el-form-item prop="bookEndTime" label="默认离店时间：">
        <el-time-picker format="HH:mm"
              value-format="HH:mm" v-model="formData.bookEndTime" placeholder="请输入" />
      </el-form-item>
      <el-form-item prop="clockRoomHours" label="钟点房时长：">
        <el-input-number v-model="formData.clockRoomHours" :min="1" :max="23" @change="handleChange" placeholder="请输入" /><span>小时</span>
      </el-form-item>
      <div style="text-align: center; padding: 20px; width: 100%">
        <el-button class="submit-btn" @click="handleSave">保存</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
    <LocationMap
      :visible="locationMapDialog"
      :lnglat="
        (formData.xpoint && formData.xpoint + ',' + formData.ypoint) || ''
      "
      @close="locationMapDialog = false"
      @confirm="confirmLnglat"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LocationMap from '@/components/common/locationMap/index'
import AreaCascader from '@/components/common/areaCascader'
export default {
  components: { LocationMap, AreaCascader },
  props: {
    shopId: {
      type: String,
      default: null
    },
    shopTypeList: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      formData: {},
      fullArea: '',
      rules: {
        storeName: [{ required: true, message: '请输入门店名称', trigger: 'blur' },],
        contact: [{ required: true, min: 11, max: 11, message: '请输入联系电话', trigger: 'blur' }],
        storeType: [{ required: true, message: '请选择门店类型', trigger: 'change' }],
        address: [{ required: true, message: '请填写门店地址', trigger: 'blur' }]
      },
      locationMapDialog: false
    }
  },
  created() {
    if (this.shopId) {
      this.getDetail();
    } else {
      this.initFormData();
    }
  },
  watch: {
    fullArea(val) {
      console.log(val)
      if (Array.isArray(val)) {
        this.formData.areaCode = val[2]
      }
    }
  },
  methods: {
    ...mapActions(["fetchData"]),

    // 确认同步经纬度
    confirmLnglat(obj) {
      this.formData.xpoint = obj.lng;
      this.formData.ypoint = obj.lat;
    },

    // 编辑：获取详情
    getDetail() {
      this.fetchData({
        url: 'SHOP.GET_DETAIL',
        params: { id: this.shopId }
      }).then(res => {
        if (res) {
          this.formData = res;
          this.fullArea = [res.provinceCode || '', res.cityCode || '', res.areaCode || ''];
        }
      })
    },

    // 新增：初始化formData
    initFormData() {
      this.formData = {
        storeName: '',
        contact: '',
        storeType: 1,
        address: '',
        xpoint: '',
        ypoint: '',
        areaCode: '',
        bookStartTime: '',
        bookEndTime: '',
        clockRoomHours: '',
      }
    },

    // 保存
    handleSave() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.fetchData({
            url: 'SHOP.POST_SAVE',
            method: 'post',
            headers: { "Content-Type": "application/json" },
            params: this.formData,
            flag: true,
          }).then(res => {
            if (res && res.data) {
              this.$message.success('操作成功！')
              this.$eventBus.emit('update-global-shop')
              this.handleCancel(true)
            } else {
              this.$message.error(res.msg || '操作失败！')
            }
          })
        }
      })
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    }
  }
}
</script>

<style lang="less" scoped>
.shop-edit-modal {
  .detail-address {
    margin-top: 10px;
    width: 100%;
  }
  :deep(.el-cascader) {
    width: 100% !important;
  }
}
</style>